import { render, staticRenderFns } from "./safeHealSurvey.vue?vue&type=template&id=7dfc6b38"
import script from "./safeHealSurvey.vue?vue&type=script&lang=js"
export * from "./safeHealSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dfc6b38')) {
      api.createRecord('7dfc6b38', component.options)
    } else {
      api.reload('7dfc6b38', component.options)
    }
    module.hot.accept("./safeHealSurvey.vue?vue&type=template&id=7dfc6b38", function () {
      api.rerender('7dfc6b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/safeHealSurvey.vue"
export default component.exports